export const FAQ_ITEMS = [
  {
    q: `What services does Lunar Ambitions offer?`,
    a: `Lunar Ambitions specializes in facial treatments and skin care services tailored to your unique skin needs. Services include custom facials, nano needling, deep cleansing treatments, exfoliation, extractions, and targeted treatments for concerns like acne, hyperpigmentation, and aging. Book your preferred service directly on the homepage.`,
    links: [{ match: `homepage`, href: `/`, testId: `faq-homepage-link` }],
  },
  {
    q: `How long does a facial appointment take?`,
    a: `Most facial appointments are around 50 minutes. Add-on treatments like dermaplaning can extend the session by an additional 30 minutes, with some appointments running up to 90 minutes. First-time clients should allow an extra 10 to 15 minutes for a brief skin care consultation before the session begins.`,
  },
  {
    q: `How should I prepare for my appointment?`,
    a: `You are welcome to arrive with or without makeup. If possible, avoid using retinol or exfoliating acids (like AHAs or BHAs) for 2 to 3 days before your appointment. Please let me know during booking if you have any known skin sensitivities, allergies, or active breakouts so I can tailor your treatment accordingly.`,
  },
  {
    q: `Do you work with all skin types?`,
    a: `Yes. Treatments are customized for every client regardless of skin type, including dry, oily, combination, sensitive, and mature skin. During your consultation I will assess your skin and select products and techniques suited specifically to you.`,
  },
  {
    q: `Is a facial safe if I have sensitive skin?`,
    a: `Absolutely. I work with sensitive skin regularly and take a gentle, thoughtful approach. Please let me know about any sensitivities or reactions you have experienced in the past so I can avoid potential irritants and choose the most appropriate products for your skin.`,
  },
  {
    q: `How often should I get a facial?`,
    a: `For most people, once a month is ideal for maintaining healthy skin. However, the right frequency depends on your skin goals and concerns. During your first visit I can recommend a personalized treatment schedule based on your skin condition.`,
  },
  {
    q: `What should I expect during my first visit?`,
    a: `Your first visit begins with a brief consultation where we discuss your skin concerns, goals, and any relevant health history. I will then assess your skin and recommend a treatment. The experience is relaxing and designed to leave your skin glowing. You are always welcome to ask questions before, during, or after your treatment.`,
  },
  {
    q: `Will my skin be red or irritated after a facial?`,
    a: `Some mild redness or flushing is normal immediately after a facial, especially if extractions were performed. This typically subsides within a few hours. I will let you know what to expect based on your specific treatment and recommend any post-care steps to keep your skin calm and hydrated.`,
  },
  {
    q: `Do you offer services for men?`,
    a: `Yes, skincare is for everyone. Men are welcome and I tailor every treatment to the individual. Men often have specific concerns like razor irritation, enlarged pores, or congested skin, and I address those with the same level of care and expertise.`,
  },
  {
    q: `Can I get a facial if I am pregnant?`,
    a: `Yes, I offer pregnancy-safe facials. Please let me know at the time of booking so I can ensure the products and techniques I use are appropriate for you. I avoid certain active ingredients during pregnancy and will adjust the treatment accordingly.`,
  },
  {
    q: `How do I book an appointment?`,
    a: `You can book online at https://book.squareup.com/appointments/lur0h9l47kubxi/location/LHNNP5Y1WCSHS/services or call us at (407) 538-9402. We recommend booking in advance to secure your preferred time. Same-day appointments may be available depending on the schedule.`,
    links: [
      {
        match: `https://book.squareup.com/appointments/lur0h9l47kubxi/location/LHNNP5Y1WCSHS/services`,
        href: `https://book.squareup.com/appointments/lur0h9l47kubxi/location/LHNNP5Y1WCSHS/services`,
        external: true,
        testId: `faq-booking-link`,
      },
      { match: `(407) 538-9402`, href: `tel:+14075389402`, testId: `faq-phone-link` },
    ],
  },
  {
    q: `What is your cancellation policy?`,
    a: `I ask for at least 24 hours notice to cancel or reschedule. Late cancellations and no-shows forfeit the $25 deposit. Please see my full Cancellation Policy page for details.`,
    links: [{ match: `Cancellation Policy`, href: `/cancellation-policy`, testId: `faq-cancellation-policy-link` }],
  },
  {
    q: `Do you offer gift cards?`,
    a: `Yes. Gift cards are available from $100 up and make a wonderful gift. You can purchase here.`,
    links: [
      {
        match: `purchase here`,
        href: `https://app.squareup.com/gift/ML1JMKJBA7K52/order`,
        external: true,
        testId: `faq-gift-card-link`,
      },
    ],
  },
  {
    q: `Where is the studio located?`,
    a: `Lunar Ambitions is located in Orlando, Florida. The studio operates by appointment, so please contact me for the exact address when you book.`,
  },
  {
    q: `What products do you use?`,
    a: `I use high-quality, professional-grade skincare products selected for their efficacy and safety. My approach is rooted in European skincare traditions, prioritizing ingredients that nourish and respect the skin. If you have specific concerns about ingredients or known allergies, please let me know before your appointment.`,
  },
];
